export default __webpack_public_path__ + "static/media/7ef65c8f2ad0839c.7bf11c967d0427e1786486592cde04d4.svg";